module.exports = __webpack_public_path__ + "static/img/background.ad956632.svg";